<div class="pagination-wrapper">
  <a
    href="javascript:void(0);"
    [class.disabled]="currentPage === 1"
    (click)="onPageChange(currentPage - 1)"
    title="Previous"
  >
    <app-svg-icon
      [iconName]="'previous.svg'"
      [width]="'15px'"
      [height]="'15px'"
      [style.fill]="'#666'"
    ></app-svg-icon>
  </a>
  @for (i of pageNumbers; track i) {
    @if (i !== "...") {
      <a
        href="javascript:void(0);"
        (click)="onPageChange(i)"
        [class.active]="currentPage === i"
      >
        {{ i }}
      </a>
    }
    @if (i === "...") {
      <span class="ellipsis">...</span>
    }
  }

  <a
    href="javascript:void(0);"
    [class.disabled]="currentPage * pageSize >= totalItems"
    (click)="onPageChange(currentPage + 1)"
    title="Next"
  >
    <app-svg-icon
      [iconName]="'next.svg'"
      [width]="'15px'"
      [height]="'15px'"
      [style.fill]="'#666'"
    ></app-svg-icon>
  </a>
</div>
